import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const COMING_SOON_PAGE = lazy(()=> import('../../pages/presentation/ComingSoon'));
const RELEASE_NOTES_PAGE = lazy(()=> import('../../pages/presentation/ReleaseNotes'));

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}
			{/* <Route path='*' element={<PAGE_404 />} /> */}
			<Route path='*' element={<COMING_SOON_PAGE />} />
			<Route path='/release-notes' element={<RELEASE_NOTES_PAGE />} />
		</Routes>
	);
};

export default ContentRoutes;
